import { SEO_PAGES } from "./pagesContent";

// City and service pages linked from the nav (as sub-items of the matching
// home section) and the footer. Labels live in the locale files (nav.sub.*).
export const PAGE_LINKS = [
  { id: "seca", section: "servicios", href: SEO_PAGES.seca.path },
  { id: "refrigerada", section: "servicios", href: SEO_PAGES.refrigerada.path },
  { id: "delicias", section: "cobertura", href: SEO_PAGES.delicias.path },
  { id: "chihuahua", section: "cobertura", href: SEO_PAGES.chihuahua.path },
];
